export class ChecklistEquipamento {
  public Id: number;
  public EquipamentoId: number;
  public ChecklistId: number;
  public MedidorUltimaExecucao: number = 0;
  public DataUltimaExecucao: Date = new Date();
  public Repetir: boolean;
  public ChecklistString:string = "";
}
